var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_377_6702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 6.80148C24 7.18595 23.8542 7.57023 23.5625 7.86227L7.86094 23.564C7.57031 23.8546 7.18594 23.9999 6.80156 23.9999C6.41719 23.9999 6.03234 23.8541 5.74078 23.5624L0.437531 18.2577C0.145828 17.9671 0 17.5827 0 17.1984C0 16.814 0.145828 16.4296 0.437531 16.1376L2.98425 13.5909L5.63597 16.2426C5.7818 16.3884 5.97403 16.4616 6.16613 16.4616C6.59081 16.4616 6.91566 16.1185 6.91566 15.712C6.91566 15.5198 6.84248 15.3275 6.69661 15.1819L4.04484 12.5296L6.16594 10.408L8.81766 13.0598C8.96344 13.2056 9.15572 13.2788 9.34781 13.2788C9.75502 13.2788 10.0973 12.9528 10.0973 12.5293C10.0973 12.337 10.0241 12.1448 9.87834 11.9991L7.22812 9.3468L9.34922 7.22523L12 9.87648C12.1459 10.0223 12.3381 10.0955 12.5302 10.0955C12.9548 10.0955 13.2797 9.75217 13.2797 9.34595C13.2797 9.15367 13.2065 8.96144 13.0606 8.8158L10.4089 6.16408L12.5305 4.04298L15.1822 6.6947C15.328 6.84053 15.5203 6.9137 15.7124 6.9137C16.137 6.9137 16.4619 6.57058 16.4619 6.16417C16.4619 5.97194 16.3887 5.77966 16.2428 5.63402L13.5911 2.9823L16.1378 0.435578C16.4295 0.143875 16.8142 -0.00195312 17.1986 -0.00195312C17.583 -0.00195312 17.9674 0.143875 18.2594 0.435578L23.561 5.73714C23.8547 6.03273 24 6.41711 24 6.80148Z",
    fill: "#66676B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_377_6702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasure);
export default __webpack_public_path__ + "static/media/measure.d5ecebfb7b6713745fb19b6a38010af5.svg";
export { ForwardRef as ReactComponent };